import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** safeley merges tailwind classes to resolve style conflicts */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
